import { Validateable } from "./interfaces/validateable";

export class Term extends Validateable {
	private name: string = "";
	private signed_by_user: boolean = false;
	private source: string = "";
	private type: string = "";
	private version: string = "";

	private original_signed_by_user: boolean = false; // Not received from API

	public getName(): string {
		return this.name;
	}

	public getSource(): string {
		return this.source;
	}

	public hasSigned(): boolean {
		return this.signed_by_user;
	}

	public setSigned(b: boolean): void {
		this.signed_by_user = b;
	}

	public getType(): string {
		return this.type;
	}

	public setType(type: string): void {
		this.type = type;
	}

	public originalHasSigned(): boolean {
		return this.original_signed_by_user;
	}

	public originalSetSigned(b: boolean): void {
		this.original_signed_by_user = b;
	}
}
